import { render } from "./bulkActions.vue?vue&type=template&id=73daf7c8"
import script from "./bulkActions.vue?vue&type=script&lang=js"
export * from "./bulkActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__